import { render, staticRenderFns } from "./installation-image-slideshow.vue?vue&type=template&id=5463f54e"
import script from "./installation-image-slideshow.vue?vue&type=script&lang=js"
export * from "./installation-image-slideshow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports